// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-main{display:-webkit-box;display:flex;-webkit-box-flex:1;flex:1 0 auto;max-width:100%;-webkit-transition:.2s cubic-bezier(.4,0,.2,1);transition:.2s cubic-bezier(.4,0,.2,1)}.v-main:not([data-booted=true]){-webkit-transition:none!important;transition:none!important}.v-main__wrap{-webkit-box-flex:1;flex:1 1 auto;max-width:100%;position:relative}@-moz-document url-prefix(){@media print{.v-main{display:block}}}", ""]);
// Exports
module.exports = exports;
